import { render, staticRenderFns } from "./UserTrainingStats.vue?vue&type=template&id=a8d735d4"
import script from "./UserTrainingStats.vue?vue&type=script&lang=js"
export * from "./UserTrainingStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports